export default __webpack_public_path__ + "static/media/FinacLogoSmall.d001448a.svg";